import { render, staticRenderFns } from "./chapterExercises.vue?vue&type=template&id=92d81ce8"
import script from "./chapterExercises.vue?vue&type=script&lang=js"
export * from "./chapterExercises.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports